import { oldSiteServiceApi } from "../../app/oldSiteApi";
import { GetQueryArgsType } from "../../types";

export const oldSitesApi = oldSiteServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    oldLogin: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/v3/profile/login",
        method: "POST",
        body: data,
      }),
      // async onQueryStarted(_, { queryFulfilled, dispatch }) {
      //   try {
      //     const { data } = await queryFulfilled;

      //     console.log(data);
      //   } catch (err) {}
      // },
    }),
    oldSiteSendVerification: builder.query<
      any,
      GetQueryArgsType<{ token: string }>
    >({
      query: (args) => ({
        url: "/api/v3/send-verification-code",
        ...args,
      }),
    }),
    oldSiteVerifyEmail: builder.query<
      any,
      GetQueryArgsType<{ code: number; token: string }>
    >({
      query: (args) => ({
        url: "/api/v3/verify-email",
        ...args,
      }),
    }),
    topupPortal: builder.query<any, GetQueryArgsType<{ token: string }>>({
      query: (args) => ({
        url: `https://api.sheba.xyz/v3/businesses/11/topup-portal`,
        ...args,
      }),
    }),
  }),
});

export const {
  useOldLoginMutation,
  useOldSiteSendVerificationQuery,
  useLazyOldSiteVerifyEmailQuery,
  useLazyTopupPortalQuery,
} = oldSitesApi;
